/**
 * List of events used by price filter widget
 *
 */
export const priceFilter = {
  PRICE_FILTERS_APPLIED: 'PriceFilter.FilterApplied'
}
